import { useAccountRateFieldApi } from '../api';

export const useAccountRatesTAccCpsMin = () => {
  const result = useAccountRateFieldApi({
    field: 'T_ACC.CPS_MIN',
  });
  return result;
};
